var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-16"},[_c('h2',{staticClass:"text-center"},[_vm._v("404")]),_c('h6',{staticClass:"text-center"},[_vm._v("Documento não encontrado")])])
}]

export { render, staticRenderFns }